import './App.css';
import { ContactScreen } from './screens/ContactScreen'
import { ProjectScreen } from './screens/ProjectScreen'
import { QualificationScreen } from './screens/QualificationScreen'
import { AboutScreen } from './screens/AboutScreen'
import { HiremeScreen } from './screens/HiremeScreen'
import { ProjectScreenById } from './screens/ProjectScreenById'
import { Header } from './components/Header'
import { HeaderMobile } from './components/HeaderMobile';
import { Footer } from './components/Footer'
import { FooterMobile } from './components/FooterMobile';
import { BrowserRouter as Router, Route } from 'react-router-dom'

function App() {

  return (
    <div className="App">
      {typeof window ==='object' && window.innerWidth>500 ?<Header/> : <HeaderMobile/>}
      
      <Router>
  
          {/* <Route path="/contact" component={ContactScreen} exact/> */}

          <Route path="/projects" component={ProjectScreen} exact />

          <Route path="/qualification" component={QualificationScreen} exact />

          <Route path="/hire" component={HiremeScreen} exact />

          <Route path="/projects/:id" component={ProjectScreenById} exact/>

          <Route path="/" component={AboutScreen} exact/>

      </Router>
      
      {typeof window ==='object' && window.innerWidth>500 ?<Footer/> : <FooterMobile/>}
    </div>
  );
}
export default App;
